import i18n from 'constants/translation/i18n';

const dependencyAreasBPR = (t?: any) => {
  const entries = [
    {
      area: 'riskToControl',
      title: t ? t('RISK_CONTROL_GAPS') : 'Risk - Control Gaps Dependency',
      href: '/dependency_bpr/risks_controls_gaps'
    },
    {
      area: 'processes',
      title: t ? t('PROCESSES') : 'Processes',
      href: '/dependency_bpr/processes'
    }
  ];
  return entries;
};

export default dependencyAreasBPR;
